import { render } from "./Contactview.vue?vue&type=template&id=a5244e24&scoped=true"
import script from "./Contactview.vue?vue&type=script&lang=js"
export * from "./Contactview.vue?vue&type=script&lang=js"

import "./Contactview.vue?vue&type=style&index=0&id=a5244e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5244e24"]])

export default __exports__